import { onDocumentReady } from "../utils/dom";

class Collapsable extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        onDocumentReady(() => {
            this.headerElement = this.querySelector("[data-component='header'");
            this.bodyElement = this.querySelector("[data-body='header']");
            this.init();
            if (!document.querySelector('expended-accordion.active')) {
                this.classList.add('active');
            }
        })
    }

    init() {
        this.headerElement.addEventListener("click", () => {
            this.closeAllCollapsibles();
            this.toggle();
        });
    }

    toggle() {
        this.classList.toggle("active");
    }
    closeAllCollapsibles() {
        const allCollapsibles = document.querySelectorAll('expended-accordion');
        allCollapsibles.forEach(collapsible => {
            if (collapsible !== this && collapsible.classList.contains('active')) {
                collapsible.toggle();
            }
        });
    }
}

customElements.define('expended-accordion', Collapsable);

class CollapsableAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        onDocumentReady(() => {
            this.headerElement = this.querySelector("[data-header='header'");
            this.bodyElement = this.querySelector("[data-bodyComponent='header']");
            this.init();
            if (!document.querySelector('collapsible-accordion.close')) {
                this.classList.add('close');
            }
        })
    }

    init() {
        this.headerElement.addEventListener("click", () => {
            this.closeAllCollapsibles();
            this.toggle();
        });
    }

    toggle() {
        this.classList.toggle("close");
    }
    closeAllCollapsibles() {
        const allCollapsibles = document.querySelectorAll('collapsible-accordion');
        allCollapsibles.forEach(collapsible => {
            if (collapsible !== this && collapsible.classList.contains('close')) {
                collapsible.toggle();
            }
        });
    }
}

customElements.define('collapsible-accordion', CollapsableAccordion);

const resetPasswordModals = document.querySelectorAll(".reset-modal");
const unShowLoginModals = document.querySelectorAll(".login-modal");
const resetPasswordButtons = document.querySelectorAll(".reset-button");
const cancelReset = document.querySelector(".cancel-reset");
const signUpButtons = document.querySelectorAll(".sign-up-button");
const registerForms = document.querySelectorAll(".register-form");
const loginForms = document.querySelectorAll(".login-form");
const loginButtons = document.querySelectorAll(".login__btn");

const showResetPasswordModal = () => {
    resetPasswordModals.forEach(modal => {
        modal.style.display = 'block';
    })
    unShowLoginModals.forEach(item => item.classList.add('active'));
}

const hideResetPasswordModal = () => {
    resetPasswordModals.forEach(modal => {
        modal.style.display = 'none';
    })
    unShowLoginModals.forEach(item => item.classList.remove('active'));
}

const showRegisterModal = () => {
    loginForms.forEach(form => {
        form.classList.toggle('display-desktop');
    });
    registerForms.forEach(form => {
        form.classList.toggle('display-desktop');
    });
}

const attachEventListener = () => {
    resetPasswordButtons?.forEach(button => {
        button?.addEventListener("click", showResetPasswordModal);
    })
    cancelReset?.addEventListener("click", hideResetPasswordModal);
    signUpButtons?.forEach(button => {
        button?.addEventListener("click", showRegisterModal);
    });
    loginButtons?.forEach(button => {
        button?.addEventListener("click", showRegisterModal);
    })
}

onDocumentReady(attachEventListener);